import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/app/admin-settings/global-settings")({
  component: Outlet,
  beforeLoad: (ctx) => ({
    getTitle: () => ctx.context.t && ctx.context.t("GlobalSettings"),
  }),
})
